import cloneDeep from 'lodash/cloneDeep';
import { Container } from 'pixi.js';
import type { Scene } from '../../app/SceneManager';
import type { App } from '../../app/App';
import type { GameSceneOptions } from './GameSceneOptions';
import { exitToMainMenu } from '../../behaviours/exitToMainMenu';
import type { LevelData } from '../level/LevelData';
import type { BoardModel } from '../boardMVC/models/board/BoardModel';
import { GameSceneController } from '../GameSceneController';
import type { TrayModel } from '../boardMVC/models/tray/TrayModel';

export class GameSceneMVC implements Scene {
  public readonly id = 'Game';

  public readonly view = new Container();

  private readonly app: App;

  private readonly gameSceneController: GameSceneController;

  constructor(public readonly options: GameSceneOptions) {
    this.app = options.app;

    this.gameSceneController = new GameSceneController(
      {
        app: this.app,
        root: this.view,
      },
      { ...options },
    );

    this.gameSceneController.onExitToMainMenu.connect(() => {
      exitToMainMenu(this.app);
    });

    // testPopulate();
  }

  public onActivated(): void {
    this.gameSceneController.activate();
  }

  public update(deltaTime: number): void {
    this.gameSceneController.update(deltaTime);
  }

  public resize(): void {
    //
  }

  public destroy(): void {
    this.gameSceneController.destroy();
  }

  public exportLevelData(): LevelData | null {
    return this.gameSceneController?.exportLevelData();
  }

  public exportOriginalLevelData(): LevelData {
    const { options } = this;
    const { stateController } = this.app;
    return cloneDeep(options.saveProgress ? stateController.originalLevelData : options.levelData);
  }

  public debugGetBoardModel(): BoardModel {
    return this.gameSceneController.getBoardModel();
  }

  public debugGetTrayModel(): TrayModel {
    return this.gameSceneController.getTrayModel();
  }

  public debugShowLevelComplete(): void {
    this.gameSceneController.debug.triggerWinFlow();
  }

  public debugShowLevelFail(): void {
    this.gameSceneController.debug.triggerFailFlow();
  }
}
